import { render, staticRenderFns } from "./wallet-redMoney.vue?vue&type=template&id=58c11366&"
import script from "./wallet-redMoney.vue?vue&type=script&lang=js&"
export * from "./wallet-redMoney.vue?vue&type=script&lang=js&"
import style0 from "./wallet-redMoney.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports